<manip-text backgroundColor="{{backgroundColor}}" strokeColor="{{strokeColor}}" strokeWidth="{{strokeWidth}}" frame="{{frame}}" font="{{font}}" fontSize="{{fontSize}}"> 
</manip-text>